import { Eyebrow, Reveal } from "./Reveal";
import { RealPhoto } from "./PhotoSlot";

const POINTS = [
  { n: 1, title: "Ceiling voids, light fittings, smoke detectors and vents" },
  { n: 2, title: "Power points, switch plates and cabling runs" },
  { n: 3, title: "Displays, conference phones, speakers and the AV cupboard" },
  { n: 4, title: "Furniture, upholstery, fixtures and anything gifted or delivered" },
  { n: 5, title: "Adjoining walls, shared partitions and the floors above and below, where accessible" },
  { n: 6, title: "Windows and sightlines from outside the building" },
];

export default function InspectionDiagram() {
  return (
    <section id="process" className="border-t border-hairline py-12 sm:py-16" data-testid="inspection-process-section">
      <div className="site-x">
        <Reveal>
          <Eyebrow>The inspection</Eyebrow>
          <h2 className="mt-4 max-w-xl font-head font-extrabold tracking-tight h-sec">
            A room has more hiding places than most people picture.
          </h2>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 items-start gap-10 lg:grid-cols-2">
          <ol className="flex flex-col" data-testid="inspection-points-list">
            {POINTS.map(({ n, title }) => (
              <li
                key={n}
                data-testid={`inspection-point-${n}`}
                className="flex items-start gap-4 border-l-2 border-transparent py-4 pl-5"
              >
                <span className="mt-0.5 text-xs font-semibold tracking-[0.16em] text-violet">
                  {String(n).padStart(2, "0")}
                </span>
                <span className="font-head text-[0.9375rem] font-bold leading-snug">{title}</span>
              </li>
            ))}
          </ol>

          <Reveal delay={0.1} className="lg:sticky lg:top-24">
            <div className="rounded-xl border border-hairline bg-surface p-5 sm:p-7">
              <RealPhoto
                src="/media/ceiling-void-reach.jpg"
                alt="A technician reaching into an open ceiling void during the physical inspection"
                testid="inspection-points-image"
              />
              <p className="mt-4 border-t border-hairline pt-3 text-[0.625rem] uppercase tracking-[0.16em] text-sub">
                Fig. 02 — Ceiling voids and light fittings
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
